import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { StatisticsResource } from '../../../services/resources/statistics.resource';

@Component({
    selector: 'sl-total-registered-percent',
    templateUrl: './total-registered-percent.component.html',
    styleUrls: ['./total-registered-percent.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TotalRegisteredPercentComponent implements OnInit {
    label: string;
    amount: number;

    private readonly statisticsResource = inject(StatisticsResource);

    ngOnInit(): void {
        this.statisticsResource.getTotalRegisteredPercent().subscribe(r => {
            this.label = r.value.label;
            this.amount = r.value.value;
        });
    }
}
